import {IPoint, ISize, ShapeSchemeType} from "@consts/types";
import {Rectangle} from "@common/new-drawer/entity";

const BACKGROUND_RECTANGLE_ID = '0000';

const createBackgroundRectangle = (scope: paper.PaperScope) => {
  const backgroundColor = new scope.Color(255, 255, 255, 1);
  const { width: viewWidth, height: viewHeight } = scope.view.bounds
  const viewSize: ISize = { width: viewWidth, height: viewHeight };
  const zeroPoint: IPoint = { x: 0, y: 0 };

  return  new Rectangle(scope, {
    id: BACKGROUND_RECTANGLE_ID,
    type: ShapeSchemeType.rectangle,
    color: backgroundColor,
    track: null,
    shapeScheme: {
      point: zeroPoint,
      size: viewSize
    }
  });
}

export default createBackgroundRectangle;